const FEATURE_HELP_URLS = {
  agent_bots: 'https://etisalna.app/hc/agent-bots',
  agents: 'https://etisalna.app/hc/agents',
  audit_logs: 'https://etisalna.app/hc/audit-logs',
  campaigns: 'https://etisalna.app/hc/campaigns',
  canned_responses: 'https://etisalna.app/hc/canned',
  channel_email: 'https://etisalna.app/hc/email',
  channel_facebook: 'https://etisalna.app/hc/fb',
  custom_attributes: 'https://etisalna.app/hc/custom-attributes',
  dashboard_apps: 'https://etisalna.app/hc/dashboard-apps',
  help_center: 'https://etisalna.app/hc/help-center',
  inboxes: 'https://etisalna.app/hc/inboxes',
  integrations: 'https://etisalna.app/hc/integrations',
  labels: 'https://etisalna.app/hc/labels',
  macros: 'https://etisalna.app/hc/macros',
  message_reply_to: 'https://etisalna.app/hc/reply-to',
  reports: 'https://etisalna.app/hc/reports',
  sla: 'https://etisalna.app/hc/sla',
  team_management: 'https://etisalna.app/hc/teams',
  webhook: 'https://etisalna.app/hc/webhooks',
  billing: 'https://etisalna.app/pricing',
  saml: 'https://etisalna.app/hc/saml',
  captain_billing: 'https://etisalna.app/hc/captain_billing',
};

export function getHelpUrlForFeature(featureName) {
  return FEATURE_HELP_URLS[featureName];
}
